/**
 * Formats a byte count as a human-readable file size using decimal (1000-based) units.
 * < 1000 KB -> KB (no decimals), >= 1000 KB -> MB, >= 1000 MB -> GB (1 decimal each).
 */
export default (sizeBytes: number): string => {
  const kb = Math.floor((sizeBytes || 0) / 1000);

  if (kb < 1000) {
    return `${kb} KB`;
  }

  const mb = kb / 1000;
  if (mb < 1000) {
    return `${mb.toFixed(1)} MB`;
  }

  const gb = mb / 1000;
  return `${gb.toFixed(1)} GB`;
};
